import { Box, Typography, Paper } from '@mui/material';
import { ReactNode } from 'react';

interface ComponentShowcaseProps {
  title: string;
  description: string;
  code: string;
  children: ReactNode;
}

const ComponentShowcase = ({ title, description, code, children }: ComponentShowcaseProps) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>

      {/* Visual Example */}
      <Box
        sx={{
          p: 3,
          mb: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'background.default',
        }}
      >
        {children}
      </Box>

      {/* Code Example */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          backgroundColor: '#1E1E1E',
          borderRadius: 1,
          overflow: 'auto',
        }}
      >
        <Typography
          component="pre"
          sx={{
            fontFamily: '"Fira Code", "Courier New", monospace',
            fontSize: '0.875rem',
            color: '#D4D4D4',
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {code}
        </Typography>
      </Paper>
    </Paper>
  );
};

export default ComponentShowcase;
